// extracted by mini-css-extract-plugin
export default {"contactBtn":"GreenBtn_contactBtn__7IDp1","contactLink":"GreenBtn_contactLink__qDhhK"};